/**
 * Périodes de l'écran Métriques d'un projet, en minutes. Le backend borne la fenêtre à 31 jours et à
 * 500 points (`ResourceMetrics`) ; au-delà de 7 jours de relevés fins il lit le cumul horaire.
 */
export const METRIC_WINDOWS = { hour: 60, day: 24 * 60, week: 7 * 24 * 60 } as const;
export type MetricWindow = keyof typeof METRIC_WINDOWS;
export const DEFAULT_METRIC_WINDOW: MetricWindow = 'hour';

export const asMetricWindow = (value: unknown): MetricWindow =>
  typeof value === 'string' && Object.hasOwn(METRIC_WINDOWS, value)
    ? (value as MetricWindow)
    : DEFAULT_METRIC_WINDOW;
